import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from '@/store/features/baseRtkQuery';
import { AdminTool, CreateAdminToolRequest, UpdateAdminToolRequest } from '@/services/models/AdminTool';

export const adminToolsApiSlice = createApi({
    reducerPath: 'adminToolsApi',
    baseQuery: baseQueryWithReAuth,
    tagTypes: ['AdminTool'],
    endpoints: (builder) => ({
        getAllAdminTools: builder.query<AdminTool[], void>({
            query: () => '/AdminTool',
            providesTags: ['AdminTool'],
        }),
        getAdminToolById: builder.query<AdminTool, string>({
            query: (id) => `/AdminTool/${id}`,
            providesTags: (result, error, id) => [{ type: 'AdminTool', id }],
        }),
        createAdminTool: builder.mutation<AdminTool, CreateAdminToolRequest>({
            query: (data) => ({
                url: '/AdminTool',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['AdminTool'],
        }),
        updateAdminTool: builder.mutation<AdminTool, { id: string; data: UpdateAdminToolRequest }>({
            query: ({ id, data }) => ({
                url: `/AdminTool/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'AdminTool', id }, 'AdminTool'],
        }),
        deleteAdminTool: builder.mutation<void, string>({
            query: (id) => ({
                url: `/AdminTool/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AdminTool'],
        }),
    }),
});

export const {
    useGetAllAdminToolsQuery,
    useGetAdminToolByIdQuery,
    useCreateAdminToolMutation,
    useUpdateAdminToolMutation,
    useDeleteAdminToolMutation,
} = adminToolsApiSlice;
